import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import map from 'lodash/map';
import { Spin } from 'antd';
import { allFiltersSelector } from '@store/metricLens/base/selectors';
import {
  StyledCellWrapper,
  StyledChartContainer,
  StyledSkeleton,
} from '../styled';
import useTimeseries from '../../hooks/useTimeseries';
import { BaseChart } from '@components/common';
import { createOptions } from './utils';
import { get } from 'lodash';
import useTooltipSync, { METRIC_LENS_TOOLTIP_EVENT } from '@components/metrics-panel-hz/hooks/useTooltipSync';

const Line = ({ column, unit, rowData }) => {
  const allFilters = useSelector(allFiltersSelector);
  const colors = map(allFilters, 'color');
  const filters = map(allFilters, 'filter.name');
  const metric = column.dataKey;

  const [instance, setInstance] = useState(null);
  // chart instance with init option
  const chartInstanceRefCb: any = useCallback((instance) => {
    setInstance(instance);
  }, []);

  const { isLoading, data } = useTimeseries({ row: rowData, enabled: false, metric });

  useEffect(() => {
    if(instance) {
      const chartOption = createOptions({ seriesData: data, colors, filters, unit });
      instance.setOption(chartOption, { notMerge: true });
    }
  }, [instance, data, colors, filters, unit]);


  useTooltipSync({
    instance,
    tag: `${metric}::${rowData.id}`,
    enabled: true,
    eventName: METRIC_LENS_TOOLTIP_EVENT
  });

  return (
    <StyledCellWrapper>
      {isLoading ? (
        <StyledSkeleton>
          <Spin />
        </StyledSkeleton>
      ) : (
        <StyledChartContainer>
          <BaseChart
            key={metric}
            chartId={metric}
            chartInstanceRefCb={chartInstanceRefCb}
            style={{ height: '100%' }}
          />
        </StyledChartContainer>
      )}
    </StyledCellWrapper>
  );
};

export default React.memo(Line);
